<zk-checkout-container *ngIf="cart">
	<div
		*ngIf="
			cart.items?.plan ||
			(cart.suggestedContent?.suggestion.isSelected &&
				cart.suggestedContent?.plan) as plan
		"
		class="zk-flex"
	>
		<img
			*ngIf="plan.imageUrl"
			class="
				zk-flex-none zk-h-10 zk-w-10 zk-mr-4 zk-rounded-full zk-object-cover
			"
			src="{{ plan.imageUrl }}"
			alt="{{ plan.name }}"
		/>
		<div class="zk-flex-1 zk-overflow-hidden">
			<div class="zk-flex zk-items-center zk-justify-between zk-mb-2">
				<span class="zk-text-1 zk-truncate">
					{{ plan.name }}
				</span>
				<span
					class="
						zk-bg-primary-checkout-light
						zk-text-primary
						zk-text-sm
						zk-leading-6
						zk-px-2
						zk-ml-2
						zk-rounded
					"
				>
					<span class="zk-font-thick">
						{{ cart.currency | zkCurrencySymbol }}
						{{ plan.price | zkPrice: cart.currency }}
					</span>
					<span *ngIf="plan.period" class="zk-font-base">
						/
						{{
							(plan.period.period === 'year' ? 'L_YEAR' : 'L_MONTH')
								| translate
								| titlecase
						}}
					</span>
				</span>
			</div>
			<div *ngIf="plan?.definition?.description">
				<markdown>{{ plan.definition.description }}</markdown>
			</div>
			<div
				*ngIf="cart.suggestedContent?.suggestion.isSelected"
				class="zk-mt-4 zk-flex zk-justify-end"
			>
				<button zkAnchor zkColorMode="grey">
					{{ 'CHECKOUT.REMOVE' | translate }}
				</button>
			</div>
		</div>
	</div>
</zk-checkout-container>
